<template>
  <ul class="desktop-mega-menu__list">
    <li
      v-for="(sublink, index) in sublinksArray"
      :key="index"
      class="desktop-mega-menu__list-item"
    >
      <h3
        class="desktop-mega-menu__list-title"
      >
        <a
          :href="sublink.url"
          class="link desktop-mega-menu__list-link"
          v-text="sublink.title"
        />
      </h3>
      <ul
        v-if="sublink.grandlinks?.length"
        class="desktop-mega-menu__grandlist"
      >
        <li
          v-for="(grandlink, idx) in sublink.grandlinks"
          :key="idx"
          class="desktop-mega-menu__grandlist-item"
        >
          <a
            :href="grandlink.url"
            class="desktop-mega-menu__grandlist-link"
            v-text="grandlink.title"
          />
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>

/**
 * Component: Mega Menu List
 * -----------------------------------------------------------------------------
 * @param {Array}  [sublinks] - Formatted 2nd level links array.
 * @param {Number} [maxLength] - The maximum number of links that will be displayed in the mega menu.
 */

export default {
  name: 'MegaMenuList',

  props: {
    sublinks: {
      type: Array,
      default: () => [],
    },
    maxLength: {
      type: Number,
      default: null,
    },
  },

  computed: {

    /**
     * Truncate `sublinks` array based on the passed max number of displayed
     * sublinks (for different types of megamenus)
     */
    sublinksArray() {
      if (!this.maxLength) {
        return this.sublinks
      }

      return this.sublinks.slice(0, Number(this.maxLength)) || []
    },
  },
}
</script>
